import { createFileRoute, } from '@tanstack/react-router';
export const Route = createFileRoute('/client/account/delete')({
    staticData: {
        hideClientAccountView: true,
    },
});
//# sourceMappingURL=ClientAccountDeleteRoute.js.map